import { rankingData } from '@/mocks/home';

function TrendIcon({ trend }: { trend: string }) {
  if (trend === 'up') return <i className="ri-arrow-up-line text-accent-500 text-sm"></i>;
  if (trend === 'down') return <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>;
  return <i className="ri-subtract-line text-foreground-400 text-sm"></i>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            实时更新的剧集热度排名，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-lg border border-background-200/60 overflow-hidden">
            {rankingData.map((item, idx) => (
              <a
                key={item.rank}
                href="#ranking"
                className={`flex items-center gap-4 px-5 py-4 hover:bg-background-200/40 transition-colors cursor-pointer ${
                  idx < rankingData.length - 1 ? 'border-b border-background-200/60' : ''
                }`}
              >
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-md text-sm font-bold flex-shrink-0 ${
                    item.rank === 1
                      ? 'bg-primary-500 text-background-50'
                      : item.rank === 2
                        ? 'bg-primary-400 text-background-50'
                        : item.rank === 3
                          ? 'bg-primary-300 text-background-50'
                          : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {item.title}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.category}</span>
                  </div>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs font-medium text-foreground-600 whitespace-nowrap">{item.hot}</span>
                  <TrendIcon trend={item.trend} />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}